import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { StyledSkeleton } from './styles.js';

const DEFAULT_WIDTH = '200px';
const DEFAULT_HEIGHT = '48px';
const Skeleton = (_a) => {
    var { width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT, round } = _a, props = __rest(_a, ["width", "height", "round"]);
    return (React.createElement(StyledSkeleton, Object.assign({ "aria-busy": true, role: "progressbar", width: width, height: height, round: round }, props)));
};

export { Skeleton as default };
